export default __webpack_public_path__ + "static/media/ok.a610486e.svg";